exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-comps-shop{position:relative}.header-comps-shop:after{content:attr(data-tips);white-space:nowrap;position:absolute;top:100%;left:50%;padding:3px 5px;margin-top:3px;color:#fff;font-size:12px;background:#5b5b5b;border-radius:3px;-webkit-transform:translateX(-50%);transform:translateX(-50%);display:none}.header-comps-shop:hover:after{display:block}", ""]);

// exports
